<template>
  <div class="alert-tag">{{ text }}</div>
</template>
<script>
export default {
  name: "alert-tag",
  props: {
    text: String,
  },
};
</script>
